import type {FontData} from '@Libraries/font-library';
import { initFonts} from '@Libraries/font-library';
import {useEffect, useState} from 'react';
import {openErrorModal} from '@Modals/error-modal';
import {useAppSelector} from '@/hooks';

interface UseGetFancyTextFontsResult {
  fonts: Array<FontData> | null;
  isLoading: boolean;
}

export function useGetFancyTextFonts(): UseGetFancyTextFontsResult {
  const fancyTextFonts = useAppSelector((state) => {
    return state.fontSelector.fancyTextFonts as Array<FontData> | null;
  });
  const [isLoading, setIsLoading] = useState(true);

  useEffect((): void => {
    if (!fancyTextFonts) {
      initFonts()
        .catch(() => {
          openErrorModal({
            message: window.i18next.t('pmwjs_error_message'),
          });
        })
        .finally((): void => {
          setIsLoading(false);
        });
    } else {
      setIsLoading(false);
    }
  }, []);

  return {fonts: fancyTextFonts, isLoading};
}
